import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref } from "vue"
import _imports_0 from '@/assets/themeThree/logo.png'
import _imports_1 from '@/assets/themeThree/caller.png'


const _hoisted_1 = { class: "groupList" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"padding-right":"10px"} }
const _hoisted_4 = ["src"]

import { computed, inject, ref, } from 'vue'
import { useRouter } from 'vue-router'
import { playClickSound } from '@/utils/media'
import { useI18n } from 'vue-i18n';
import { useActivityStore } from '@/stores/activity'
import { useUserStore } from '@/stores/user'
import PwaAntiBlockingPopup from '../common/pwaAntiBlockingPopup.vue'
import PwaStatusPopup from '../common/pwaStatusPopup.vue'
import { handleMenuClick, SideMenuListItem } from '@/view/components/supportFunction'

export default /*@__PURE__*/_defineComponent({
  __name: 'sideNavbar',
  props: {
    listGameData: {}
  },
  emits: ['intallPWA', 'openContactPopup', 'goToGamePanelSlide', 'openPWA'],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const activityStore = useActivityStore()
const userStore = useUserStore()
const { t } = useI18n();
const show = ref(false)
const router = useRouter()
const menuList = computed<SideMenuListItem[]>(() => activityStore.activityList)
const isRotating = ref(false);
const collectPopupRef = ref()
const collectTimeDropPopupRef = ref()
const agentRef = ref()

const emits = __emit
const pwaPopupRef = ref()
const pwaPopupStatusRef = ref()
const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)
const goToGamePannel = (data: any) => {
   show.value = false
   emits('goToGamePanelSlide', data)
}
const openContactPopup = () => {
   emits('openContactPopup')
}
const openSidebar = () => {
   show.value = true
}
const sidebarRef = ref<any>(null);

const resetScroll = () => {
   if (sidebarRef.value?.$el) {
      sidebarRef.value.$el.scrollTop = 0;
   }
   const popupEl = document.querySelector('.van-popup--left');
   if (popupEl) {
      popupEl.scrollTop = 0;
   }
};
const closeSidebar = () => {
   if (isRotating.value) return;
   isRotating.value = true;

   setTimeout(() => {
      show.value = false;
   }, 200);

   setTimeout(() => {
      isRotating.value = false;
   }, 1000);
}
const goToGameLog = () => {
   router.push('/sd-gamelog')
}
const props = __props

const menuClick = (name: any) => {
   if(name === 'pwa_reward'){
      emits('openPWA')    
   }
   handleMenuClick(name, router, agentRef, collectPopupRef, collectTimeDropPopupRef,
      pwaPopupRef, pwaPopupStatusRef, show, canRecievedRewards.value, isOpen.value, t
   )
}


__expose({
   openSidebar,
   closeSidebar
})


return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: show.value,
    "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
    onClickOverlay: _cache[1] || (_cache[1] = () => _unref(playClickSound)()),
    position: "left",
    round: "",
    onOpened: resetScroll,
    ref_key: "sidebarRef",
    ref: sidebarRef,
    style: { height: '100%', width: '70%', zIndex: '10002', padding: '0px 0px 48px' }
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_row, {
        class: "navBar",
        justify: "space-between"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "5",
            onClick: closeSidebar,
            class: "header_item_menu"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_icon, {
                name: "wap-nav",
                color: "#fff",
                size: "45",
                class: _normalizeClass({ 'rotate-animation': isRotating.value })
              }, null, 8, ["class"])
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "18",
            class: "header_item_logo"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.listGameData, (item) => {
          return (_openBlock(), _createBlock(_component_van_row, {
            class: "game_list",
            key: item.id,
            onClick: ($event: any) => (goToGamePannel(item)),
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "8",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "game_icon",
                    src: item.customIcon,
                    alt: ""
                  }, null, 8, _hoisted_2)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "16",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(item.showName)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "reportBtn",
        onClick: goToGameLog
      }, _toDisplayString(_ctx.$t('common.bettingRecords')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_row, {
            class: "game_list",
            key: index,
            onClick: ($event: any) => (menuClick(item.name)),
            align: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "6",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "game_icon",
                    src: item.activity_icon,
                    alt: ""
                  }, null, 8, _hoisted_4)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_van_col, {
                span: "16",
                class: "game_img_col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(_unref(t)(`activityName.${item.name}`)), 1)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _createVNode(_component_van_row, {
        class: "caller",
        onClick: openContactPopup
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_col, {
            span: "18",
            style: {"border-left":"3px solid blue","padding-left":"15px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.support')), 1),
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("span", null, "24/7")
              ], -1))
            ]),
            _: 1
          }),
          _createVNode(_component_van_col, {
            span: "6",
            style: {"display":"flex","justify-content":"right"}
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                src: _imports_1,
                alt: "",
                width: "55%",
                style: {"padding-right":"10px"}
              }, null, -1)
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})